import axios from "axios";

const BASE = "/admin/analytics";

export const fetchRegistrationFunnel = (days) =>
  axios.get(`${BASE}/registration-funnel`, { params: { days } });

/**
 * A conversion of `null` means "no registrations in this period", which is not
 * the same as 0%. Showing `0%` there would read as a broken funnel instead of an
 * empty one.
 */
export const formatConversion = (value) => (value == null ? "—" : `${value}%`);

/** Bar width for a funnel step, clamped so a resent-email overshoot stays inside. */
export const stepWidth = (step, startCount) => {
  if (!startCount) return 0;
  return Math.max(2, Math.min(100, Math.round((step.count / startCount) * 100)));
};
